import {AuthorityDto} from "@shared/dto";
import {createReducer, on} from "@ngrx/store";
import * as AuthorityActions from "./authority.actions";

export const AUTHORITY_FEATURE_KEY = 'authorities';

export interface AuthorityState {
  data: AuthorityDto[] | null;
  loading: boolean;
  error: any | null;
}

export const initialState: AuthorityState = {
  data: null,
  loading: false,
  error: null,
}

export const authorityReducer = createReducer(
  initialState,
  on(AuthorityActions.readAuthorities, (state) => ({ ...state, loading: true, error: null })),
  on(AuthorityActions.readAuthoritiesSuccess, (state, { data }) => ({ ...state, data, loading: false })),
  on(AuthorityActions.readAuthoritiesFailure, (state, { error }) => ({ ...state, error, loading: false })),
);
